import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormFieldComponent } from '../form-field/form-field.component';
import { IIcon } from '../../../icon/icon.component';
import {
  buildButtonTappedTrackingAction,
  I2gNgTrackingService,
} from 'i2g-ng-tracking';

@Component({
  selector: 'i2g-dialog-field',
  templateUrl: 'dialog-field.component.html',
  styleUrls: ['dialog-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogFieldComponent extends FormFieldComponent {
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() hideToggleButton = false;
  @Input() value: string;
  @Input() emptyText: string;
  @Input() addText: string;
  @Input() editText: string;
  @Input() showDivider = true;
  @Input() icon: IIcon;
  @Input() trackingId: string;
  @Input() toggleInputE2eId: string;
  @Input() toggleLabelE2eId: string;
  @Input() labelE2eId: string;

  @Output() clickIcon: EventEmitter<void> = new EventEmitter<void>();
  @Output() clickSetup: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService,
    private _trackingService: I2gNgTrackingService
  ) {
    super(changeDetectorRef, translateService);
  }

  setupClicked() {
    const prefix = this.value ? 'edit' : 'add';
    this._trackingService.trackEvent(
      null,
      buildButtonTappedTrackingAction(`${prefix}_${this.trackingId}`)
    );
    this.clickSetup.emit();
  }
}
